import { render } from "./studentsInfo.vue?vue&type=template&id=4df2c183&scoped=true"
import script from "./studentsInfo.vue?vue&type=script&lang=js"
export * from "./studentsInfo.vue?vue&type=script&lang=js"

import "./studentsInfo.vue?vue&type=style&index=0&id=4df2c183&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4df2c183"]])

export default __exports__